import useQuery, { Query, QueryOptions } from './useQuery';
import { HttpMethod } from './useFetch';
import { useUser } from '../UserAccess/useUser';

export interface UserQuerySpec {
    path: string;
    method?: HttpMethod;
    body?: unknown;
}

export default function useUserQuery<Resp>(spec: UserQuerySpec, options?: QueryOptions<Resp>): Query<Resp> {
    const user = useUser();
    return useQuery<Resp>({
        path: spec.path,
        headers: user.fetchHeaders,
        method: spec.method,
        body: spec.body,
    }, options);
}